import { Sparkles } from 'lucide-react';
import { useTranslation } from '../../../lib/i18n';
import { useGenericBi } from '../../../lib/use-generic-bi';
import { Button, Typography } from '../ui';
import styles from './BriefSlot.module.css';
import { upgradeHref } from '../../../lib/upgrade-origin';

// "Unlock morning meetings" — the slot when the morning-brief routine is CREDIT-paused: the daily
// meeting is locked and upgrading unlocks it. Distinct from `ActivateBrief` (the user's own pause),
// whose "turn it on" ask would be a lie without credits: sparkles instead of the lock, and the CTA is
// the accent upgrade button to the package picker — the same destination every credits CTA opens.
// Mirrors the native `BriefUpgradeCard`s.

export function UpgradeBrief() {
  const { t } = useTranslation();
  const { logPageClickBi } = useGenericBi();

  return (
    <section className={styles.slot} aria-labelledby="brief-upgrade-title">
      <p className={styles.eyebrow}>
        <Sparkles size={16} aria-hidden />
        <Typography variant="h3" color="strong" component="span" id="brief-upgrade-title">
          {t('brief.upgrade.title')}
        </Typography>
      </p>
      <Typography variant="h3" component="p" className={styles.body}>
        {t('brief.upgrade.body')}
      </Typography>
      <div className={styles.actions}>
        <Button
          color="accent"
          size="medium"
          href={upgradeHref('brief_upgrade')}
          onClick={() => {
            logPageClickBi({ page_name: 'home', button_name: 'brief_upgrade' });
          }}
        >
          {t('brief.upgrade.cta')}
        </Button>
      </div>
    </section>
  );
}
